import React from 'react';
import {CreateDeliveryForm, DistributionProduct} from '../models/distribution.model';
import {BarChart3} from 'lucide-react';

interface QuantityFieldProps {
  formData: CreateDeliveryForm;
  selectedProduct: DistributionProduct | undefined;
  onInputChange: (field: keyof CreateDeliveryForm, value: any) => void;
}

const QuantityField: React.FC<QuantityFieldProps> = ({
  formData,
  selectedProduct,
  onInputChange
}) => {
  if (!selectedProduct || selectedProduct.hasSerial) {
    return null;
  }

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
        <BarChart3 className="h-4 w-4" />
        الكمية
      </label>
      <input
        type="number"
        min="1"
        max={selectedProduct.availableQuantity}
        value={formData.quantity}
        onChange={(e) => onInputChange('quantity', parseInt(e.target.value) || 1)}
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-brand-500"
        placeholder="أدخل الكمية المطلوبة"
        required
      />
      {selectedProduct && (
        <p className="text-xs text-gray-500 mt-1">
          {selectedProduct.hasSerial
            ? 'الكمية تتحدد تلقائياً حسب عدد السيريلات المختارة'
            : `الحد الأقصى: ${selectedProduct.availableQuantity} قطعة`
          }
        </p>
      )}
    </div>
  );
};

export default QuantityField;
